import { render, staticRenderFns } from "./DeleteEventDialog.vue?vue&type=template&id=f80c9bfa&"
import script from "./DeleteEventDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteEventDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports